if (!customElements.get('cart-upsell-mobile')) {
  // Bloc « Vous aimerez aussi » du drawer en mobile : le titre replie / déplie
  // la liste. Le drawer est re-rendu à chaque modification du panier, donc
  // l'état est mémorisé en sessionStorage (même mécanique que cart-echantillons).
  class CartUpsellMobile extends HTMLElement {
    static STORAGE_KEY = 'cart_upsell_mobile_collapsed';

    connectedCallback() {
      const button = this.querySelector('.upsell_title');
      if (!button) return;

      let collapsed = false;
      try {
        collapsed = sessionStorage.getItem(CartUpsellMobile.STORAGE_KEY) === '1';
      } catch (e) {
        /* sessionStorage indisponible : on reste déplié */
      }
      this.setCollapsed(collapsed, button);

      button.addEventListener('click', () => {
        const next = !this.classList.contains('is-collapsed');
        this.setCollapsed(next, button);
        try {
          sessionStorage.setItem(CartUpsellMobile.STORAGE_KEY, next ? '1' : '0');
        } catch (e) {
          /* idem */
        }
      });
    }

    setCollapsed(collapsed, button) {
      this.classList.toggle('is-collapsed', collapsed);
      button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    }
  }

  customElements.define('cart-upsell-mobile', CartUpsellMobile);
}
